<script lang="ts">
  // components
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  // props
  export let showDeleteModal: boolean = false;
  export let closeDeleteModal: () => void;
  export let removeDistributorCredentials: () => void;
  export let distributorNameToRemove: string;
  export let isRemoving: boolean = false;

  // functions
  const onRemove = () => {
    removeDistributorCredentials();
    closeDeleteModal();
  };
</script>

<Modal bind:show={showDeleteModal} closeOnBackgroundClick={false} fizzModal={true} size={"medium"}>
  <div class="fizz-inset-square-24" id="credential-management-delete-modal">
    <header class="fizz-space-between fizz-stack-24">
      <h4 class="fizz-heading-4 fizz-text-large">Remove Distributor</h4>
      <div
        id="credential-management-delete-modal-close-button"
        data-testId="credential-management-delete-modal-close-button"
        on:click|preventDefault={closeDeleteModal}
      >
        <Icon type="X" extraClassNames="fizz-text-brand cursor-pointer" height="16" width="16" />
      </div>
    </header>
    <section class="fizz-text-medium fizz-stack-24" data-grid-area="main">
      Are you sure you want to remove <span class="fizz-text-strong">{distributorNameToRemove}</span
      > credentials?
    </section>
    <footer class="fizz-flex-row fizz-justify-end">
      <button
        class="fizz-button"
        id="credential-management-delete-modal-cancel"
        data-testId="credential-management-delete-modal-cancel-button"
        on:click|preventDefault={closeDeleteModal}>Cancel</button
      >
      <button
        class="fizz-button-secondary"
        id="credential-management-delete-modal-remove"
        data-testId="credential-management-delete-modal-remove-button"
        disabled={isRemoving}
        on:click|preventDefault={onRemove}>Remove</button
      >
    </footer>
  </div>
</Modal>
